
//const serverUrl = "http://localhost:64359/";
//const serverUrl= "http://192.168.1.5:64359/";
const serverUrl = "https://api.melinarahmani.com/";
const serverUrl12 = "http://10.85.14.250:64359/";
const apiUrl = `${serverUrl}api`;

export {serverUrl, apiUrl}
